import { Delete, Edit } from "@mui/icons-material";
import {
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	Paper,
	Radio,
	TextField,
	Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestType } from "../Enums/Test";
import CreateQuestModal from "../components/CreateQuestModal";
import Loader from "../components/Loader";
import { Question } from "../interfaces/Test";
import {
	CreateTest,
	DeleteTest,
	GetTest,
	UpdateTest,
} from "../requester/functions";
import { getUrlId } from "../utilities/validate";

interface IProps {}

const TestPage = (props: IProps) => {
	const navigate = useNavigate();
	const location = useLocation();

	const { enqueueSnackbar } = useSnackbar();

	const [questions, setQuestions] = useState<Question[]>([]);
	const [selectedQuest, setSelectedQuest] = useState<Question | undefined>(
		undefined
	);
	const [testName, setTestName] = useState<string>("");
	const [succesCount, setSuccesCount] = useState<number>(0);
	const [open, setOpen] = useState<boolean>(false);

	const [idTest, setIdTest] = useState<number>(0);

	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [isEdit, setIsEdit] = useState<boolean>(false);

	useEffect(() => {
		const idTest: string = getUrlId(location.pathname);
		if (idTest === "create") setIsLoaded(true);
		else {
			GetTest({ id: parseInt(idTest) }, (resp) => {
				if (resp.status === "ok" && resp.data) {
					setTestName(resp.data.name);
					setSuccesCount(resp.data.success_count);
					setQuestions(resp.data.questions);
					setIsEdit(true);
					setIsLoaded(true);
					setIdTest(resp.data.id || 0);
				} else {
					navigate("/tests");
				}
			});
		}
	}, []);

	return isLoaded ? (
		<div className="flex flex-col gap-3 items-start">
			<TextField
				label="Название"
				value={testName}
				onChange={(ev) => {
					setTestName(ev.target.value);
				}}
			/>
			<div className="flex flex-col gap-3 w-60">
				{questions.map((q, qi) => (
					<Paper key={`quest-${qi}`} className="p-3 w-full">
						<Typography>{q.title}</Typography>
						<div className="flex flex-col">
							{q.type !== QuestType.text ? (
								q.answers.map((a, ai) =>
									q.type === QuestType.single ? (
										<FormControlLabel
											key={`answer-${qi}${ai}`}
											value={a.id}
											control={
												<Radio
													checked={q.correct_answers.includes(a.id as never)}
												/>
											}
											label={a.text}
										/>
									) : q.type === QuestType.multiple ? (
										<FormControlLabel
											label={a.text}
											control={
												<Checkbox
													checked={q.correct_answers.includes(a.id as never)}
												/>
											}
										/>
									) : null
								)
							) : (
								<TextField
									value={
										q.correct_answers.length > 0 ? q.correct_answers[0] : ""
									}
									multiline
								/>
							)}
							{!isEdit ? (
								<div className="flex  w-full justify-end">
									<IconButton
										color="error"
										onClick={() => {
											setQuestions((qes) => {
												qes.splice(questions.indexOf(q));
												return [...qes];
											});
										}}
									>
										<Delete />
									</IconButton>
									<IconButton
										color="primary"
										onClick={() => {
											setSelectedQuest(q);
											setOpen(true);
										}}
									>
										<Edit />
									</IconButton>
								</div>
							) : null}
						</div>
					</Paper>
				))}
				<Button
					onClick={() => {
						setSelectedQuest(undefined);
						setOpen(true);
					}}
				>
					Добавить
				</Button>
			</div>
			<div className="flex items-center mt-3">
				<TextField
					type={"number"}
					value={succesCount}
					onChange={(ev) => {
						setSuccesCount(parseInt(ev.target.value));
					}}
					className="w-1/2 !mr-2"
				/>
				<Typography>/ {questions.length}</Typography>
			</div>
			<div className="flex gap-2">
				<Button
					variant="contained"
					disabled={
						!testName ||
						questions.length === 0 ||
						succesCount > questions.length ||
						succesCount <= 0 ||
						!succesCount
					}
					onClick={() => {
						if (!isEdit)
							CreateTest(
								{
									name: testName,
									questions: questions,
									success_count: succesCount,
								},
								(resp) => {
									if (resp.status === "ok" && resp.data) {
										enqueueSnackbar("Тест успешно создан", {
											variant: "success",
										});
										navigate(`/test/${resp.data.id}`);
									} else {
										enqueueSnackbar(resp.message, { variant: "error" });
									}
								}
							);
						else
							UpdateTest(
								{
									id: idTest,
									name: testName,
									questions: [],
									success_count: succesCount,
								},
								(resp) => {
									if (resp.status === "ok") {
										enqueueSnackbar("Тест успешно обновлен", {
											variant: "success",
										});
									} else {
										enqueueSnackbar(resp.message, { variant: "error" });
									}
								}
							);
					}}
				>
					Сохранить
				</Button>
				{isEdit ? (
					<IconButton
						color="error"
						onClick={() => {
							const ready = window.confirm(
								"Вы уверены, что хотите удалить тест?"
							);
							if (ready)
								DeleteTest(
									{
										id: idTest,
										is_delete: true,
									},
									(resp) => {
										if (resp.status === "ok") navigate("/tests");
									}
								);
						}}
					>
						<Delete />
					</IconButton>
				) : null}
			</div>

			<CreateQuestModal
				open={open}
				onClose={(quest?: Question, edit?: boolean) => {
					if (quest)
						if (!edit)
							setQuestions((q) => {
								q.push(quest);
								return [...q];
							});
						else if (selectedQuest) {
							setQuestions((q) => {
								q[q.indexOf(selectedQuest)] = quest;
								return [...q];
							});
							setSelectedQuest(undefined);
						}
					setOpen(false);
				}}
				quest={selectedQuest}
			/>
		</div>
	) : (
		<Loader />
	);
};

export default TestPage;
